import MainScreen from "./components/MainScreen";

function App() {
  return (
    <div className="container">
      <MainScreen />
    </div>
  );
}

export default App;
